import { useTranslation } from 'react-i18next';

import { LANGUAGES } from 'utils/Constants';

import { CustomAutocomplete } from 'components/shared/DropDown/CustomAutocomplete';

export const UserLanguageSelector = ({
  selectedLanguage,
  onLanguageChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="label-title">{t('Langue')}*</div>
      <CustomAutocomplete
        disabled={!LANGUAGES.length}
        list={LANGUAGES}
        value={selectedLanguage}
        getOptionDisabled={(option) => false}
        setValue={onLanguageChange}
        groupBy={(option) => false}
        getOptionLabel={(option) => {
          return t(option.language);
        }}
      />
    </>
  );
};
